<template>
    <div>
      <v-row justify="center" align="center" style="margin-top:20px;">
        <v-col cols="12" sm="12" md="9" lg="9" >
          <canvas :id="name" width="500" height="300" ></canvas>
        </v-col>
      </v-row>
    </div>
</template>
<script>
import Chart from 'chart.js';
export default {
  name: 'Bar-Chart',
  props: ['name', 'chartData', 'options'],
  data() {
    return {
      toggle_filter: 0
    }
  },
  mounted() {
    setTimeout(() => {
      this.loadCharts()
    }, 1000)
  },
  watch: {
    chartData() {
      this.loadCharts()
    }
  },
  methods: {
    async loadCharts() {
      let data = await this.chartData
      this.renderChart(data)
    },
    renderChart(chartData) {
      var ctx = document.getElementById(this.name);

      const config = {
        type: 'bar',
        data: chartData,
        options: this.options
        // options: {
        //   responsive: true,
        //   interaction: {
        //     intersect: false
        //   },
        //   scales: {
        //     x: {
        //       stacked: true
        //     },
        //     y: {
        //       stacked: true
        //     }
        //   }
        // }
      };
      if (window.barChart !== undefined) {
        window.barChart.destroy()
      }
      // eslint-disable-next-line
      window.barChart = new Chart(ctx, config)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Bar.vue?6bb18a82